var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor br rounded-ittybitty"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],ref:"editor",attrs:{"id":_vm.id,"name":_vm.name},domProps:{"value":(_vm.content)},on:{"input":function($event){if($event.target.composing)return;_vm.content=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }